/**
 * Created by along on 1/12/16.
 */

define(function (require) {
    "use strict";

    var
        $ = require("jquery"),
        _ = require("underscore"),
        Marionette = require("marionette"),
        dialogTemplate = require("ui/dialog/templates/dialog.tmpl"),
        DomEvents = require("infra-util/DomEvents"),
        Loader = require("ui/loader/Loader"),
        Logger = require("logger"),


        ESCAPE_KEY_CODE = 27,
        PERMUTATION = {
            A: "default-dialog",
            B: "medium-dialog",
            C: "medium-center-dialog",
            D: "large-center-dialog"
        },

        THEME = {
            DEFAULT: "default-theme",
            NIGHT: "night-theme"
        };

    var Dialog = Marionette.Layout.extend({

        template: dialogTemplate,
        className: "dialog-inner-contain",
        ui: {
            dialog: ".dialog",
            dialogContainer: ".dialog-container",
            insideViewContainer: ".dialog-inside-view-container"
        },
        regions: {
            dialogViewRegion: ".dialog",
            dialogContainerViewRegion: ".dialog-container",
            insideViewRegion: ".dialog-inside-view-container"
        },
        events: {
            "click .dialog-close-btn" : "_onCloseButtonClick"
        },

        initialize: function(options) {
            this._initialize(options);
        },

        onRender: function() {
            this._onRender();
        },
//PUBLIC
        renderInsideView: function () {
            this.logger.debug("Rendering Dialog public renderInsideView" , "Dialog:renderInsideView");
            this._renderInsideView();
        },

        showLoader: function (options) {
            this.logger.debug("Dialog showLoader" , "Dialog:showLoader");
            this._showLoader(options);
        },

        closeLoader: function () {
            this.logger.debug("Dialog closeLoader" , "Dialog:closeLoader");
            this._closeLoader();
        },

        onClose: function(){
            this._onClose();
        },

//PRIVATE
        _initialize: function (options) {
            this.logger = Logger.getLogger("Dialog");
            this.logger.debug("Initializing Dialog", "Dialog:initialize", {options: options});
            this.pageId = (new Date()).getTime().toString();
            this.permutation = options.permutation || Dialog.PERMUTATION.A;
            this.theme = _.has(options, "theme") ? options.theme : Dialog.THEME.DEFAULT;
            this.selectedContentModel = options.selectedContentModel;
            this.innerView = options.innerView || null;
            this.context = options.context;
            this.moduleName = options.moduleName;
        },

        _onRender: function () {
            this.logger.debug("Rendering Dialog", "Dialog:onRender");
            this.ui.dialog.addClass(this.permutation);
            this.ui.dialog.addClass(this.theme);
            this._renderInsideView();

            DomEvents.on("keyup", this.pageId, this.moduleName, this.context, _.bind(this._onKeyup, this));
        },

        _renderInsideView: function() {
            this.logger.debug("Rendering Dialog _renderInsideView" , "Dialog:_renderInsideView", {innerView: this.innerView});
            if (this.innerView) {
                this.listenTo(this, "showLoader", this._showLoader);
                this.listenTo(this, "closeLoader", this._closeLoader);
                this.insideViewRegion.show(this.innerView);
            }
            else {
                this.insideViewRegion.reset();
            }
        },

        _onKeyup: function (event) {
            this.logger.debug("Dialog _onKeyup" , "Dialog:_onKeyup", {event: event});
            if (event.keyCode == ESCAPE_KEY_CODE) {
                this._onCloseButtonClick(event);
            }
        },

        _onCloseButtonClick: function (event) {
            this.logger.debug("Dialog _onCloseButtonClick" , "Dialog:_onCloseButtonClick", {innerView: this.innerView});
            if(this.innerView){
                this.innerView.trigger("dialog:closeButtonClick", {event: event});
            }
        },

        _showLoader: function (options) {
            this.logger.debug("Dialog _showLoader" , "Dialog:_showLoader", {options: options});
            var permutation = _.has(options, "permutation") ? options.permutation : Loader.PERMUTATION.A;
            var el = _.has(options, "el") ? options.el : this.ui.insideViewContainer; //".interaction-area-item-wrapper.open";
            var zIndex = _.has(options, "zIndex") ? options.zIndex : 999999;
            var text = _.has(options, "text") ? options.text : '';
            var button = _.has(options, "button") ? options.button : '';

            if (!this.loader) {
                this.loader = new Loader({
                    permutation: permutation,
                    el: el,
                    zIndex: zIndex,
                    text: text,
                    button: button
                });
                this.loader.render();
            }
        },

        _closeLoader: function () {
            this.logger.debug("Dialog _closeLoader" , "Dialog:_closeLoader", {loader: this.loader});
            if (this.loader) {
                this.loader.close();
                this.loader = null;
            }
        },

        _onClose: function() {
            this.logger.debug("Dialog _onClose" , "Dialog:_onClose", {pageId: this.pageId});
            DomEvents.off("keyup", this.pageId);
            this._closeLoader();
        }
    });
    Dialog.PERMUTATION = PERMUTATION;
    Dialog.THEME = THEME;
    Dialog.LOADER_PERMUTATION = Loader.PERMUTATION;

    return Dialog;
});
